import React, { useState, useEffect } from "react";
import {Grid} from "@material-ui/core";
import youtube from "./api/youtube";
import {SearchBar, VideoDetail, VideoList} from "./components";


import "./css/style.css";

function App(){

    const [videos, setVideos] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);

    useEffect(() => {
        alert("For better performance, it is adviseable to turn off your adblockers.");
        handleSubmit('cats');
    }, []);

    const handleSubmit = async (searchTerm) => {
        const response = await youtube.get('search', {
            params: {
                part: 'snippet',
                maxResults: 5,
                key: 'AIzaSyBJKduVHp_AZ-wY1krIkkhJ-R0g4MD7QhA',
                q: searchTerm,
            }
        });

        setVideos(response.data.items);
        setSelectedVideo(response.data.items[0]);
    }

    const onVideoSelect = (video) => {
        setSelectedVideo(video);
    } 

    return (
        <Grid style={{justify: "center"}} container spacing={10}>
            <Grid item xs={11}>
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <SearchBar onFormSubmit={handleSubmit} />
                    </Grid>
                    <Grid item xs={8}>
                        <VideoDetail video={selectedVideo} />
                    </Grid>
                    <Grid item xs={4}>
                        <VideoList onVideoSelect={onVideoSelect} videos={videos} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>    
    )
}

export default App;